// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View1_wrapper__ZHEBc","topicTitle":"View1_topicTitle__3DnZx"};